// extracted by mini-css-extract-plugin
export default {"previewHeadline":"HWyml_TkKgRE_fwdIT9Z","webhookExampleContainer":"DyFnVWcR065E9krIGBLL","paragraphWithBottomMargin":"h5uIt1lCH6a1iZpR0ulj"};